import { supabase } from '../supabase';

interface Category {
  id: number;
  name: string;
}

export const fetchCategories = async (): Promise<Category[]> => {
  try {
    const { data, error } = await supabase
      .from('categories')
      .select('id, name')
      .order('name', { ascending: true });

    if (error) throw error;

    return data || [];
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const getCategories = () => {
  return supabase
    .from('categories')
    .select('id, name, description, color, image_url, icon_url')
    .order('name');
};

export const fetchOneCategory = (categoryId: number ) => {
  return supabase
  .from('categories')
  .select('id, name')
  .eq('id', categoryId)
  .single();
}